import { render, staticRenderFns } from "./AddCountry.vue?vue&type=template&id=4bf919bc"
import script from "./AddCountry.vue?vue&type=script&lang=js"
export * from "./AddCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports